import { useMutation } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { downloadFile } from '../downloadFile';

interface TransitProps {
  id: string;
}

export const useDownloadTransitReport = () => {
  return useMutation({
    mutationFn: ({ id }: TransitProps) => downloadFile(`transits/${id}/download-ncts-report`),
    onError: (error) => {
      showErrorToast(error, `Error downloading file!`);
    },
  });
};
